import { useEffect, useRef, type ReactNode } from "react";
import clsx from "clsx";

interface RegistryStatusPillProps {
  textColor: string;
  backgroundColor: string;
  children: ReactNode;
  className?: string;
}

export function RegistryStatusPill({
  textColor,
  backgroundColor,
  children,
  className,
}: RegistryStatusPillProps) {
  const ref = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    if (ref.current) {
      ref.current.style.color = textColor;
      ref.current.style.backgroundColor = backgroundColor;
    }
  }, [textColor, backgroundColor]);

  return (
    <span ref={ref} className={clsx("registry-table__status-pill", className)}>
      {children}
    </span>
  );
}
